import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import WhatsAppWeb from './WhatsAppWeb';
import { getApiBaseUrl } from './config/api';
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState('dashboard'); // 'dashboard' or 'whatsapp'
  const [selectedInstance, setSelectedInstance] = useState(null);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('user_data');
    
    if (token && userData) {
      try {
        // Verify token is still valid
        const response = await fetch(getApiBaseUrl('/me'), {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();
        
        if (data.success) {
          setUser(data.user);
        } else {
          // Token is invalid, clear storage
          localStorage.removeItem('auth_token');
          localStorage.removeItem('user_data');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        // Clear storage on error
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
      }
    }
    setLoading(false);
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
    setCurrentView('dashboard');
    setSelectedInstance(null);
  };

  const handleOpenChat = (instance) => {
    setSelectedInstance(instance);
    setCurrentView('whatsapp');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedInstance(null);
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="App">
        <Login onLogin={handleLogin} />
      </div>
    );
  }

  return (
    <div className="App">
      {currentView === 'dashboard' ? (
        <Dashboard 
          user={user} 
          onLogout={handleLogout}
          onOpenChat={handleOpenChat}
        />
      ) : (
        <WhatsAppWeb 
          selectedInstance={selectedInstance} 
          onBackToDashboard={handleBackToDashboard}
        />
      )}
    </div>
  );
}

export default App;
